import { Dispatch, useCallback, useState } from 'react'
import { getListFileMappingFormats } from 'src/app/shared/services/ClientSetupService'

export interface IFileMappingTabHook {
  fileMappingList: any
  isGettingList: boolean
  isDeleting: boolean
  setFileMappingList: Dispatch<any>
  getFileMappingList: (payload: Partial<any>) => Promise<void>
  setIsDeleting: (state: boolean) => void
}

export const useFileMappingTab = (): IFileMappingTabHook => {
  const [fileMappingList, setFileMappingList] = useState<any>({
    data: [],
    total: 0,
    pageIndex: 0,
    pageSize: 10,
  })

  const [isGettingList, setIsSettingList] = useState<boolean>(false)
  const [isDeleting, setIsDeleting] = useState<boolean>(false)

  const getFileMappingList = useCallback(async (payload: any) => {
    try {
      setIsSettingList(true)
      const res = await getListFileMappingFormats(payload)
      if (res?.data) {
        setFileMappingList(res?.data)
      }
    } catch (error) {
      console.log('ERROR: ', error)
    } finally {
      setIsSettingList(false)
    }
  }, [])

  return {
    fileMappingList,
    isGettingList,
    isDeleting,
    setFileMappingList,
    getFileMappingList,
    setIsDeleting,
  }
}
